import React from 'react';
import './index.css';
import { Label10 } from './index';
const month = { '01': 'January', '02': 'February', '03': 'March', '04': 'April', '05': 'May', '06': 'June', '07': 'July', '08': 'August', '09': 'September', '10': 'October', '11': 'November', '12': 'December' };
export const TrackerDivider = ({ timestamp="" }) => {
    const timeArr = timestamp.split("-");
    const monthNo = timeArr[1];
    const timeStr = timeArr[2] + " " + month[monthNo] + " " + timeArr[0];
    return (
        <div className="divRow" style={{ alignItems: 'center', padding: 8, paddingLeft: 16, paddingRight: 16 }}>
            <div style={{ flex: 1, height: 2, backgroundColor: 'rgba(206, 209, 217, 0.3)' }} />
            <div style={{ marginLeft: 12, marginRight: 12, marginBottom: -3 }}>
                <label className="label10" style={{ color: '#868ca1' }}>{timeStr}</label>
            </div>
            <div style={{ flex: 1, height: 2, backgroundColor: 'rgba(206, 209, 217, 0.3)' }} />
        </div>
    );
}